import { render } from "./DoubleRoom.vue?vue&type=template&id=e579054a&scoped=true"
import script from "./DoubleRoom.vue?vue&type=script&lang=js"
export * from "./DoubleRoom.vue?vue&type=script&lang=js"

import "./DoubleRoom.vue?vue&type=style&index=0&id=e579054a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e579054a"]])

export default __exports__